import React from 'react';

class MainContainer extends React.Component {
    componentDidMount() {
        // navigating between routes could have potentially wiped away espn_ui's reference to the main-container
        // this reinitializes that container after re-render
        if (window.espn_ui && window.espn_ui.Helpers.page && window.jQuery) {
            window.espn_ui.Helpers.page.container = window.jQuery('#main-container');
        }
    }

    render() {
        return (
            <div className={this.props.className}>
                {this.props.pre}
                <section id="main-container">
                    <div className="main-content">
                        {this.props.children}
                    </div>
                </section>
            </div>
        );
    }
}

MainContainer.propTypes = {
    children: React.PropTypes.node,
    className: React.PropTypes.string,
    pre: React.PropTypes.array
};

export default MainContainer;



// WEBPACK FOOTER //
// ./app/page/common/MainContainer.js